import { createFileRoute } from "@tanstack/react-router";
import { List } from "@/features/consent-solutions";

const Route = createFileRoute("/_authorized/consent-solutions/")({
  component: () => <List />,
});

export { Route };
